<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  src: string
  errorSrc?: string
  alt?: string
  className?: string
}
const props = withDefaults(defineProps<Props>(), {
  alt: 'Image',
  className: '',
})

const defaultImage = '/images/picture-not-found.jpg'
const imageSrc = ref<string>(props.src)

const handleImageError = () => {
  imageSrc.value = props.errorSrc || defaultImage
}
</script>

<template>
  <img :src="imageSrc" :alt="props.alt" :class="props.className" @error="handleImageError" />
</template>
